/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Seo_SectionInputs */

const vi_shop_seo_section = /** @type {(inputs: Shop_Seo_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO (tuỳ chọn)`)
};

/**

* @param {Shop_Seo_SectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_seo_section = /** @type {((inputs?: Shop_Seo_SectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Seo_SectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_seo_section(inputs)
});